import OutrightAddMapper from './outright-add-mapper';
import OutrightSeasonModel from '../outright-season/outright-season-model';

const OutrightAddModel = {
    mapper: OutrightAddMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    season: {
        fieldName: 'v',
        model: OutrightSeasonModel,
        modelContext: {
            sportId: 'sportId',
        },
        type: Object,
    },

    type: {
        fieldName: 't',
        type: String,
    },

    outright: {
        fieldName: 'o',
        type: Boolean,
    },
};

export default OutrightAddModel;
